import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=e629dfd2&scoped=true&"
import script from "./demo.ts?vue&type=script&lang=ts&"
export * from "./demo.ts?vue&type=script&lang=ts&"
import style0 from "./demo.styl?vue&type=style&index=0&id=e629dfd2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e629dfd2",
  null
  
)

export default component.exports